export const API_ROOT = process.env.NODE_ENV === "production" ? "/api/" : "/api/";
export const OBS_APP_ROOT = process.env.VUE_APP_OBS_APP_ROOT ||
  (process.env.NODE_ENV === "production" ? "https://obs.schwarzl-it.com/" : "http://localhost:8111/");
